module.exports = __webpack_public_path__ + "static/media/nit.45c5ed1d.jpeg";